module.exports = __webpack_public_path__ + "img/logo.8ad25167.png";